import React, { useState, useEffect } from 'react';
import { Link as ScrollLink } from 'react-scroll';

const DocumentationLayout = ({ children, toc }) => {
  const [activeLink, setActiveLink] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      const sections = toc.map(item => document.getElementById(item.id)).filter(Boolean);
      const scrollPosition = window.scrollY + 100; // Add offset for fixed header

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = sections[i];
        if (section.offsetTop <= scrollPosition) {
          setActiveLink(section.id);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [toc]);

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Sidebar for Table of Contents */}
      <aside className="w-64 bg-white shadow-md p-4 sticky top-0 h-screen overflow-y-auto">
        <h2 className="text-xl font-bold text-primary mb-4">Documentation</h2>
        <nav>
          <ul className="space-y-2">
            {toc.map((item) => (
              <li key={item.id}>
                <ScrollLink
                  to={item.id}
                  smooth={true}
                  duration={500}
                  offset={-80} // Adjust offset for fixed header
                  className={`block text-sm hover:text-primary cursor-pointer ${
                    activeLink === item.id ? 'font-semibold text-primary' : 'text-gray-700'
                  } ${item.level === 2 ? 'ml-2' : ''} ${item.level === 3 ? 'ml-4' : ''}`}
                  onClick={() => setActiveLink(item.id)}
                >
                  {item.text}
                </ScrollLink>
              </li>
            ))}
          </ul>
        </nav>
      </aside>

      {/* Main Content Area */}
      <main className="flex-1 p-6">
        {children}
      </main>
    </div>
  );
};

export default DocumentationLayout;
